import { Context, state } from 'client/app.cerebral';

export function getImages({ firebase, get, path }: Context) {
  return firebase
    .value(`images.${get(state.app.uid)}`)
    .then((response) => path.success({ images: response.value }))
    .catch((error) => path.error({ error }));
}
